




import {Component, Vue, Prop} from "vue-property-decorator";
import {ChatMessages} from "../../../../../types/chat-messages";
// @ts-ignore
import store from "../../../../store";

@Component({})

/**
 * Вывод html-шаблона с сервера в чат
 * @param message
 * @private
 */
export default class TemplateMessage extends Vue{
    @Prop({required: true}) private readonly message!: ChatMessages.Message;
}
